// extracted by mini-css-extract-plugin
module.exports = {"overlay":"src-hellospa-components-deep-integration-quota-overlay-overlay__overlay--11nwV"};